<!--
 * @Author: your name
 * @Date: 2020-08-11 21:01:30
 * @LastEditTime: 2020-08-17 10:50:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/Icon/index.vue
-->
<template lang="pug">
van-icon.material-icons(
  :color="color"
  v-bind="$attrs"
  v-on="$listeners"
  class-prefix="material-icons"
)
  slot(v-if="!name")
  | {{ name }}
</template>

<script>
export default {
  props: {
    name: String,
    color: {
      type: String,
      default: 'rgba(20, 196, 188, 1)'
    }
  },
}
</script>
